import { ProjectPhase } from "../../../constants/project-phase";
import { ProjectDates } from "../../../models";

export const getCurrentPhaseStatus = (phase: ProjectPhase, dates: ProjectDates): string => {
  switch (phase) {
    case ProjectPhase.feasibility:
      return dates.feasibility.status;
    case ProjectPhase.design:
      return dates.design.status;
    case ProjectPhase.implementation:
      return dates.implementation.status;
    case ProjectPhase.ongoingMonitoring:
      return dates.ongoingMonitoring.overallStatus;
    default:
      return "";
  }
};
